// extracted by mini-css-extract-plugin
export default {"table":"DepositsTable_table__zN4uy"};